import { createFileRoute } from '@tanstack/react-router';

import { FriendMyGamesPageWidget } from '@features/game/pages/FriendMyGamesPage/FriendMyGamesPageWidget';

export const Route = createFileRoute('/game/friend_/games')({
  component: FriendMyGamesPageWidget,
});
